"use client";

import { ChevronRight, Compass, Slash } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Breadcrumb, BreadcrumbItem, BreadcrumbLink, BreadcrumbList, BreadcrumbPage, BreadcrumbSeparator } from "@/components/ui/breadcrumb";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function InspectionParCamRaHd() {
  const {
    ref: contentRef,
    isVisible: contentVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  const {
    ref: cardRef,
    isVisible: cardVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  const capacityChips = [{
    label: "Montréal",
    value: "montreal"
  }, {
    label: "Laval",
    value: "laval"
  }, {
    label: "Longueuil",
    value: "longueuil"
  }, {
    label: "Rive-Nord/Sud",
    value: "rives"
  }];
  return <section data-section-id="440" id="inspection-par-caméra-hd" className="bg-background text-foreground relative overflow-hidden" style={{
    minHeight: "75vh"
  }}>
      {}
      <div className="absolute inset-0 z-0">
        <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1694820/img/inspection_camera_hd_drain.png" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1694820/img/inspection_camera_hd_drain.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1694820/img/inspection_camera_hd_drain.png-wvc-sizes" alt="Technicien OT Solution effectuant une inspection par caméra HD dans un drain résidentiel" className="h-full w-full object-cover" loading="lazy" decoding="async" />
      </div>

      {}
      <div className="absolute inset-0 z-10" style={{
      background: "linear-gradient(to left, hsla(222, 47%, 4%, 0.95) 0%, hsla(222, 47%, 4%, 0.8) 40%, hsla(222, 47%, 4%, 0.4) 70%, hsla(222, 47%, 4%, 0) 100%)"
    }} aria-hidden="true" />

      {}
      <div className="absolute inset-0 z-10 opacity-[0.12] mix-blend-overlay" style={{
      backgroundImage: "radial-gradient(circle at 20% 30%, var(--primary) 0, transparent 40%), radial-gradient(circle at 80% 70%, var(--secondary) 0, transparent 40%)"
    }} aria-hidden="true" />

      {}
      <div className="relative z-20 mx-auto flex w-full max-w-7xl flex-col justify-center px-6 lg:px-12" style={{
      minHeight: "75vh",
      paddingTop: "6rem",
      paddingBottom: "4rem"
    }}>
        <div className="grid grid-cols-1 items-center gap-12 lg:grid-cols-12">
          {}
          <div ref={cardRef} data-index={0} className={`order-2 lg:order-1 lg:col-span-4 transition-all duration-1000 ease-out ${cardVisible ? "opacity-100 translate-x-0" : "opacity-0 -translate-x-8"}`}>
            <div className="relative max-w-sm rounded-md border border-white/10 bg-black/40 p-6 shadow-2xl backdrop-blur-xl lg:p-7">
              {}
              <div className="absolute -top-px left-6 right-6 h-px bg-gradient-to-r from-transparent via-primary/50 to-transparent" />

              <div className="mb-4 flex items-center gap-3">
                <div className="flex h-10 w-10 items-center justify-center rounded-md border" style={{
                borderColor: "hsla(217, 91%, 60%, 0.4)",
                backgroundColor: "hsla(217, 91%, 60%, 0.15)"
              }}>
                  <Compass className="h-5 w-5" style={{
                  color: "hsl(217, 91%, 60%)"
                }} />
                </div>
                <span className="font-mono text-xs uppercase tracking-widest" style={{
                color: "hsl(217, 91%, 60%)"
              }}>
                  [01] Diagnostic
                </span>
              </div>

              <h3 className="font-default mb-3 text-xl font-semibold leading-tight text-white lg:text-2xl">
                Précision Chirurgicale
              </h3>

              <p className="mb-5 text-sm leading-relaxed text-white/80 font-default">
                Localisez l'obstruction exacte sans excavation inutile. Une clarté HD pour des décisions éclairées.
              </p>

              {}
              <div className="mb-5 rounded-md border border-white/10 bg-black/30 p-4">
                <svg viewBox="0 0 200 80" className="h-16 w-full" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                  <path d="M40 20 L40 60 M40 30 Q60 25 80 30 L120 30 Q140 25 160 30 M40 50 Q60 55 80 50 L120 50 Q140 55 160 50" stroke="hsl(217, 91%, 60%)" strokeWidth="1.2" strokeLinecap="round" />
                  <circle cx="40" cy="40" r="3" fill="hsl(217, 91%, 60%)" />
                  <circle cx="160" cy="30" r="2" fill="hsl(38, 92%, 50%)" />
                  <circle cx="160" cy="50" r="2" fill="hsl(38, 92%, 50%)" />
                  <path d="M50 40 Q100 35 150 40" stroke="hsl(38, 92%, 50%)" strokeWidth="0.8" strokeDasharray="2 3" />
                  <text x="100" y="75" textAnchor="middle" fill="hsl(210, 20%, 98%)" fontSize="6" fontFamily="JetBrains Mono" opacity="0.6">
                    SONDE ACTIVE · SCAN HD
                  </text>
                </svg>
              </div>

              <div className="flex items-center justify-between border-t border-white/10 pt-4">
                <div>
                  <div className="font-mono text-[10px] uppercase tracking-widest text-white/50">
                    Tarif de base
                  </div>
                  <div className="font-default mt-0.5 text-base font-semibold text-secondary">
                    Dès 275$
                  </div>
                </div>
                <Button variant="ghost" size="sm" className="text-white hover:bg-primary/20 hover:text-white rounded-md" asChild>
                  <Link to="/CameraInspectionPage">
                    Détails
                    <ChevronRight className="h-4 w-4" />
                  </Link>
                </Button>
              </div>
            </div>
          </div>

          {}
          <div ref={contentRef} className={`order-1 lg:order-2 lg:col-span-8 lg:ml-auto lg:max-w-2xl lg:pr-0 xl:pr-8 transition-all duration-1000 ease-out ${contentVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
            {}
            <Breadcrumb className="mb-6">
              <BreadcrumbList className="text-white/70">
                <BreadcrumbItem>
                  <BreadcrumbLink asChild className="font-mono text-xs uppercase tracking-widest text-white/60 hover:text-primary">
                    <Link to="/HomePage">OT Solution</Link>
                  </BreadcrumbLink>
                </BreadcrumbItem>
                <BreadcrumbSeparator className="text-white/40">
                  <Slash className="h-3 w-3" />
                </BreadcrumbSeparator>
                <BreadcrumbItem>
                  <BreadcrumbPage className="font-mono text-xs uppercase tracking-widest text-white">
                    Inspection Caméra
                  </BreadcrumbPage>
                </BreadcrumbItem>
              </BreadcrumbList>
            </Breadcrumb>

            {}
            <div className="mb-6 flex items-center gap-3">
              <div className="h-px w-10" style={{
              backgroundColor: "hsl(217, 91%, 60%)"
            }} />
              <span className="font-mono text-xs font-medium uppercase tracking-[0.2em]" style={{
              color: "hsl(217, 91%, 60%)"
            }}>
                Expertise en Drainage
              </span>
            </div>

            {}
            <h1 className="font-default mb-6 text-6xl font-semibold leading-[0.95] tracking-tight text-white lg:text-8xl" style={{
            fontFamily: "var(--font-serif)",
            fontStretch: "condensed"
          }}>
              Inspection
              <span style={{
              color: "hsl(217, 91%, 60%)"
            }}> /</span>
              <br />
              Caméra HD.
            </h1>

            {}
            <p className="mb-8 max-w-xl text-base leading-relaxed text-white/80 lg:text-lg font-default">
              Éliminez les devinettes. Nos systèmes d'inspection haute définition révèlent l'état réel de vos drains à Montréal, Laval et Longueuil. Spécialistes exclusifs en débouchage et diagnostic souterrain.
            </p>

            {}
            <div className="mb-8">
              <div className="mb-3 font-mono text-[10px] uppercase tracking-widest text-white/50">
                Secteurs d'intervention
              </div>
              <div className="flex flex-wrap gap-2">
                {capacityChips.map((chip, i) => <Button key={chip.value} data-index={i} variant="outline" size="sm" className="border-white/20 bg-white/5 text-white/90 hover:border-primary hover:bg-primary/10 hover:text-white rounded-md font-default">
                    {chip.label}
                  </Button>)}
              </div>
            </div>

            {}
            <div className="flex flex-wrap items-center gap-4">
              <Button size="lg" className="font-medium bg-primary text-white hover:bg-primary/90 rounded-md" asChild>
                <Link to="/ContactPage">
                  Appeler 438-367-8309
                  <ChevronRight className="h-4 w-4" />
                </Link>
              </Button>
              <Link to="/UncloggingPage" className="font-mono text-xs uppercase tracking-widest text-white/70 underline-offset-4 transition-colors hover:text-primary hover:underline">
                Voir le Débouchage
              </Link>
            </div>
          </div>
        </div>
      </div>

      {}
      <div className="absolute bottom-0 left-0 right-0 z-20 h-px" style={{
      background: "linear-gradient(to right, transparent, hsla(217, 91%, 60%, 0.4) 50%, transparent)"
    }} />
    </section>;
}